import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { COINS, fmtUsd } from "@/lib/api";

function FlowCard({ s, active, onClick, i }) {
  const total = s.inflow_usd + s.outflow_usd;
  const inPct = total ? (s.inflow_usd / total) * 100 : 50;
  const bearish = s.net_usd > 0;
  let glow = "";
  let tone = "text-slate-500";
  let Arrow = null;
  if (total) {
    glow = bearish ? "glow-in" : "glow-out";
    tone = bearish ? "text-[#FF3D00]" : "text-[#00E676]";
    Arrow = bearish ? ArrowDownRight : ArrowUpRight;
  }
  return (
    <button
      data-testid={`net-flow-card-${s.symbol}`}
      onClick={onClick}
      style={{ animationDelay: `${i * 50}ms` }}
      className={`panel rise p-3 text-left transition-colors duration-200 hover:border-[#2E3C54] ${glow} ${active ? "!border-[#00E5FF]" : ""}`}
    >
      <div className="flex items-center justify-between">
        <span className="font-display text-sm font-semibold">{s.symbol}</span>
        <span className="font-mono text-[10px] text-slate-500">{s.count} tx</span>
      </div>
      <div className={`mt-1 flex items-center gap-1 font-mono text-lg font-bold ${tone}`}>
        {Arrow && <Arrow className="h-4 w-4" />}
        {total ? fmtUsd(Math.abs(s.net_usd)) : "$0"}
      </div>
      <div className="mt-2 flex h-1.5 overflow-hidden rounded-full bg-[#1E2738]">
        <div className="bg-[#FF3D00]" style={{ width: total ? `${inPct}%` : 0 }} />
        <div className="bg-[#00E676]" style={{ width: total ? `${100 - inPct}%` : 0 }} />
      </div>
      <div className="mt-1.5 flex justify-between font-mono text-[10px] text-slate-500">
        <span>IN {fmtUsd(s.inflow_usd)}</span>
        <span>OUT {fmtUsd(s.outflow_usd)}</span>
      </div>
    </button>
  );
}

export default function NetFlowStrip({ stats, coin, onCoin }) {
  return (
    <section data-testid="net-flow-summary-card">
      <div className="mb-2 flex items-baseline justify-between">
        <p className="overline">24h net exchange flow</p>
        <p className="font-mono text-[10px] text-slate-500">
          <span className="text-[#FF3D00]">■</span> inflow = sell pressure ·{" "}
          <span className="text-[#00E676]">■</span> outflow = accumulation
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7">
        {stats.filter((s) => COINS.includes(s.symbol) || s.count > 0).map((s, i) => (
          <FlowCard key={s.symbol} s={s} i={i} active={coin === s.symbol} onClick={() => onCoin(s.symbol)} />
        ))}
      </div>
    </section>
  );
}
